import React from 'react'
import {useSelector} from 'react-redux'
import {toggle} from 'opticks/lib/optimizely'

import {TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY} from '@daedalus/core/src/auth/modules/actions'
import UserWidget from '@daedalus/atlas/src/components/shared/user/UserWidget'
import UserWidgetBSide from '@daedalus/atlas/src/components/shared/user/UserWidget/BSide'
import {ShowPasswordlessLoginPayload} from '@daedalus/core/src/auth/types/Auth'

import {
  useAccountUrl,
  useCognitoUser,
  useIsMemberPlus,
  useLogIn,
  useLogOut
} from '@daedalus/core/src/auth/modules/useCognito'

import {
  selectIsAuthenticated,
  selectIsLoading
} from '@daedalus/core/src/auth/modules/selectors'

import getAnonymousId from 'components/data/URLParams/selectors/getAnonymousId'

const UserWidgetWithStore = () => {
  const accountUrl = useAccountUrl()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const isMemberPlus = useIsMemberPlus()
  const isLoading = useSelector(selectIsLoading)
  const logIn = useLogIn()
  const logOut = useLogOut()
  const user = useCognitoUser()

  if (isLoading) return null

  const logInWithTracking = ({
    sourceComponent,
    flow
  }: {
    sourceComponent: ShowPasswordlessLoginPayload['sourceComponent']
    flow
  }) => {
    const anonymousId = getAnonymousId()
    setTimeout(
      () =>
        logIn({
          sourceComponent,
          anonymousId,
          flow
        }),
      TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY
    )
  }

  const handleLogOutClick = () => {
    if (logOut) logOut()
  }

  return toggle(
    'dq82hd-desktop-map',
    <UserWidget
      isAuthenticated={Boolean(isAuthenticated)}
      isMemberPlus={isMemberPlus}
      user={user}
      onSignIn={logInWithTracking}
    />,
    <UserWidgetBSide
      isAuthenticated={Boolean(isAuthenticated)}
      isMemberPlus={isMemberPlus}
      user={user}
      logOut={handleLogOutClick}
      accountUrl={accountUrl}
      onSignIn={logInWithTracking}
    />
  )
}

export default UserWidgetWithStore
